import ReactTable from "../../util/ReactTable";
import AsyncBlock from "../../components/forms/AsyncBlock";
import PageTitle from "../../components/layout/PageTitle";
import PageSection from "../../components/layout/PageSection";
import Button from "../../components/forms/Button";
import PageContainerFull from "../../components/layout/PageContainerFull";
import {useCallback, useMemo} from "react";
import {FlexLayout} from "../../components/flex/Flex";
import useFetch2 from "../../hooks/useFetch2";
import {Apis} from "../../util/data";
import {useNavigate} from "react-router-dom";
import * as React from "react";
import {format} from "date-fns";
import axios from "axios";
import useEditModal from "../../modals/useEditModal";
import CancelPedido from "../../components/CancelPedido";
import GenericModal2 from "../../modals/GenericModal2";
import {errorToast, successToast} from "../../components/layout/ToastStyles";

const PedidoList = () => {

  const navigate = useNavigate()
  const {loading, data, fetchData, error} = useFetch2(Apis.PROD + '/pedidos/list', []);

  const formatoFecha = 'dd/MM/yyyy HH:mm:ss';

  const {wrapper: wrapper1, editAction} = useEditModal({
    editComponent: <CancelPedido />,
    onRefresh: fetchData
  });

  // function editPedido(item) {
  //   navigate('/pedidos/edit/' + item.id)
  // }

  const siguiente = async (id) => {
    try {
      const {data} = await axios.post(Apis.PROD + '/pedidos/cambiar-estado/' + id)
      if (data) successToast("Se ha actualizado el estado")
    } catch (error) {
      errorToast("Error al cambiar estado")
      console.log(error)
    }
    await fetchData()
  }

  function detalle(id){
    navigate('/pedidos/'+id+'/detalle');
  }

  const actionsValue = useCallback(cell =>
      <FlexLayout justifyContent='center'>
        {cell.row.original.estado !== "Cancelado" && cell.row.original.estado !== "Entregado" && <Button size='xs' variant='light' onClick={() => siguiente(cell.row.original.id)}>Estado</Button>}
        <Button size='xs' variant='light' onClick={() => detalle(cell.row.original.id)}>Detalle</Button>
        {cell.row.original.estado !== "Cancelado" && cell.row.original.estado !== "Entregado" && cell.row.original.direccion?.length > 0 && <Button size='xs' variant='danger' onClick={() => editAction({
          id: cell.row.original.id
        })}>Cancelar</Button>}
      </FlexLayout>
    // eslint-disable-next-line react-hooks/exhaustive-deps
    , []);

  const fechaValue = useCallback(cell => {
    if(cell.renderValue()){
      const fechaUTC = new Date(cell.renderValue() + new Date().getTimezoneOffset() * 60000);
      return format(fechaUTC, formatoFecha)
    } else return ''
  }, []);

  const columns = useMemo(
    () => [
      {
        header: 'Codigo',
        accessorKey: 'id'
      },
      {
        header: 'Usuario',
        accessorKey: 'usuario'
      },
      {
        header: 'Fecha creacion',
        accessorKey: 'fecha',
        cell: fechaValue
      },
      {
        header: 'Dirección',
        accessorKey: 'direccion'
      },
      {
        header: 'Estado',
        accessorKey: 'estado'
      },
      {
        header: 'Fecha envio',
        accessorKey: 'fechaEnvio',
        cell: fechaValue
      },
      {
        header: 'Fecha entrega',
        accessorKey: 'fechaEntrega',
        cell: fechaValue
      },
      {
        header: 'Fecha cancelacion',
        accessorKey: 'fechaCancel',
        cell: fechaValue
      },
      {
        header: 'Acciones',
        accessorKey: 'id',
        meta: {
          headerClassName: 'text-center', // class para la cabecera
          columnClassName: 'text-center', // class para la columna
        },
        enableSorting: false, // para deshabilitar el sort
        cell: actionsValue
      }
    ]
    // eslint-disable-next-line react-hooks/exhaustive-deps
    , [data]
  )

  return (
    <PageContainerFull>

      <PageSection>
        <PageTitle title={'Pedidos'}/>

        <AsyncBlock loading={loading} error={error}>
          <ReactTable
            columns={columns}
            data={data || []}
            customSearch
            noData='No existen pedidos'
            pageSize={20}
          />
        </AsyncBlock>
      </PageSection>
      <GenericModal2 {...wrapper1} />
    </PageContainerFull>
  )
}

export default PedidoList
